function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useRef } from 'react';
import c from 'classnames';
import { useField, useFormikContext } from 'formik';
import GenericFormElement from '../GenericFormElement';
import useAriaDescribedByField from '../../../hooks/useAriaDescribedByField';
const RangeField = props => {
  const {
    name,
    className,
    label,
    unit,
    unitAfter,
    min = 0,
    max = 100,
    accuracy = 0,
    required,
    disabled,
    visualValidation,
    visualMinMax,
    verticalSpacing,
    defaultValue,
    onBlur,
    onChange,
    description,
    isLiveValidationDisabled,
    hideValidationMessage,
    ...rest
  } = props;
  const ref = useRef(null);
  const formikProps = useFormikContext();
  const [field, meta, helpers] = useField(name);
  const {
    submitCount
  } = useFormikContext();
  const {
    ariaDescribedBy
  } = useAriaDescribedByField({
    field,
    meta,
    description
  });
  useEffect(() => {
    if (ref.current) {
      ref.current.setAttribute('style', "\n        --min: ".concat(min, ";\n        --max: ").concat(max, ";\n        --val: ").concat(field.value || 0, ";\n      "));
    }
  }, [min, max, field.value]);
  const classNames = c('RangeField', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, visualMinMax && /*#__PURE__*/React.createElement("div", {
    className: "RangeField__visual-min-max"
  }, /*#__PURE__*/React.createElement("div", null, unitAfter ? "".concat(min).concat(unit || '') : "".concat(unit || '').concat(min)), /*#__PURE__*/React.createElement("div", null, unitAfter ? "".concat(max).concat(unit || '') : "".concat(unit || '').concat(max))), /*#__PURE__*/React.createElement(GenericFormElement, {
    name: name,
    label: label,
    meta: meta,
    helpers: helpers,
    visualValidation: visualValidation,
    verticalSpacing: verticalSpacing,
    defaultValue: defaultValue,
    description: description,
    submitCount: submitCount,
    isLiveValidationDisabled: isLiveValidationDisabled,
    hideValidationMessage: hideValidationMessage
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: ref,
    id: name,
    type: "range",
    min: min,
    max: max,
    step: 1 / 10 ** accuracy // ** is instead of Math.pow, as it is deprecated.
    ,
    required: required,
    disabled: disabled
  }, rest, {
    onMouseUp: e => {
      /** Set the field value to the accuracy onBlur. */
      formikProps.setFieldValue(name, Number(field.value).toFixed(accuracy));
      if (onBlur) {
        onBlur(e);
      }
    }
  }, field, {
    "aria-describedby": ariaDescribedBy,
    onBlur: e => {
      if (onBlur) onBlur(e);
      field.onBlur(e);
    },
    onChange: e => {
      if (onChange) onChange(e);
      field.onChange(e);
    }
  }))));
};
export default RangeField;